inputs-number-comma
  div(class="form-group row { error: opts.errors }" data-)
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      span.prefix(if="{opts.prefix}") {opts.prefix}
      input(class="form-control { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" type="number" value="{ opts.value }" onInput="{this.onInput}" onChange="{this.onChange}")
      span.suffix(if="{opts.suffix}") {opts.suffix}
      p.explanation(if="opts.explanation") { opts.explanation }
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
    .tooltip-wrap(if="{isShowTooltip}")
      .popper
        .num { commaNumber }
        .popper__arrow(x-arrow)
  script(type="typescript").
    this.mixin('inputs.number-comma');
  style(scoped).
    input.form-control {
      display: inline-block;
      width: auto;
    }
